var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"title"},[_vm._v("Adopt")]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.pages.content.rendered)}}),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.$route.params.slug))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67e46b34","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Adopt.vue
// module id = null
// module chunks = 